import React from 'react'

// components
import Hero from '../components/Hero';
import Clients from '../components/Clients';
import Services from '../components/Services';
import About from '../components/About';
import Contact from '../components/Contact';
import CallToAction from '../components/CallToAction';
import Brands from '../components/Brands';

function Home() {
  return (
    <div className='home'>
      <Hero  
         backgroundImage='/assets/images/bg1.png'
      />
      <Clients/>
      <Brands/>
      <About/>
      <Services/>
      <CallToAction/>
           <Contact/>
    </div>
  )
}

export default Home
